import React, { useState, useEffect } from "react";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import { DatePicker, Button, Select } from "antd";
import { Typography } from "@mui/material";
import ViewDeviceShipmentDashboard from "./ViewDeviceShipmentDashboard";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import ShipmentFields from "./ShipmentFields";
import { useDispatch } from "react-redux";
import {
  fetchBatteryHistoryRequest,
  fetchHumidityRequest,
  fetchLightRequest,
  fetchPressureRequest,
  fetchRSSIHistoryRequest,
  fetchSignalHistoryRequest,
  fetchTemperatureRequest,
  fetchTiltRequest,
} from "../../../store/actions/deviceShipmentsDashboard";
import { updateUI } from "../../../store/actions/shipment";
import { isMoreThan7Days } from "../../../global/utility/GmtToLocal";
import { calculateSerialMac } from "../../../global/utility/macAddress";

const ShipmentData = (props) => {
  const { deviceid, gateway, shipmentData } = props;
  const shipBleDeviceId = useSelector(
    (state) => state.shipment?.ui?.ui?.shipBleDeviceId
  );
  const shipNewBleDeviceId = useSelector(
    (state) => state.shipment?.ui?.ui?.shipNewBleDeviceId
  );
  const deviceName = useSelector((state) => state?.shipment?.data?.deviceName);
  const deviceType = useSelector(
    (state) => state?.shipment?.data?.deviceType?.devicetypes
  );
  const matchedDevice = deviceName?.devices?.find(
    (device) => device?.uid === shipBleDeviceId
  );
//const deviceTypeVal = matchedDevice?.devicetype || null;
  const deviceTypeVal = matchedDevice?.devicetype ?? shipmentData?.devicetype;
  const matchedDevice1 = deviceType?.find(
    (device) => device?.devicetype === deviceTypeVal
  );
  const result = {
    devicemodel: matchedDevice1?.devicemodel,
  };
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      updateUI({
        key: "ui",
        value: {
          shipNewBleDeviceId: deviceid,
          shipBleDeviceId: deviceid,
        },
      })
    );
  }, []);
  const onChangeFormat = (date, type) => {
    const formattedDate = date.format("YYYY-MM-DD");
    const formattedTime = date.format("HH:mm");
    const finalTime =
      type && formattedTime === "00:00:00" ? "23:59:59" : formattedTime;
    const formattedDateTime = `${formattedDate}T${finalTime}`;
    return new Date(formattedDateTime).toISOString();
  };
  const [startDate, setStartDate] = useState(
    isMoreThan7Days(
      shipmentData?.startdate || Date.now(),
      shipmentData?.updatedat || Date.now()
    )
      ? dayjs(shipmentData?.updatedat || Date.now()).subtract(7, "day")
      : shipmentData?.startdate
  );
  const [endDate, setEndDate] = useState(shipmentData?.updatedat);

  const onChangeStartDate = (date, dateStr) => {
    if (date && dateStr) {
      setStartDate(onChangeFormat(date));
    }
  };
  const onChangeEndDate = (date, dateStr) => {
    if (date) {
      setEndDate(onChangeFormat(date), true);
    }
  };
  const handleLastUpdatedFilterChange = (e) => {
    dispatch(
      updateUI({
        key: "ui",
        value: {
          shipNewBleDeviceId: shipBleDeviceId,
        },
      })
    );
    dispatch(
      fetchBatteryHistoryRequest({
        id: shipBleDeviceId,
        startDateTime: dayjs(startDate).toISOString(),
        endDateTime: dayjs(endDate).toISOString(),
      })
    );
    if (result?.devicemodel === "BLE") {
      dispatch(
        fetchRSSIHistoryRequest({
          id: shipBleDeviceId,
          startDateTime: dayjs(startDate).toISOString(),
          endDateTime: dayjs(endDate).toISOString(),
        })
      );
    }
    if (result?.devicemodel === "GAT") {
      dispatch(
        fetchSignalHistoryRequest({
          id: shipBleDeviceId,
          startDateTime: dayjs(startDate).toISOString(),
          endDateTime: dayjs(endDate).toISOString(),
        })
      );
    }
    if (result?.devicemodel === "GAT") {
      dispatch(
        fetchLightRequest({
          id: shipBleDeviceId,
          startDateTime: dayjs(startDate).toISOString(),
          endDateTime: dayjs(endDate).toISOString(),
        })
      );
    }
    if (result?.devicemodel === "GAT") {
      dispatch(
        fetchTiltRequest({
          id: shipBleDeviceId,
          startDateTime: dayjs(startDate).toISOString(),
          endDateTime: dayjs(endDate).toISOString(),
        })
      );
    }
    dispatch(
      fetchHumidityRequest({
        id: shipBleDeviceId,
        startDateTime: dayjs(startDate).toISOString(),
        endDateTime: dayjs(endDate).toISOString(),
      })
    );
    dispatch(
      fetchTemperatureRequest({
        id: shipBleDeviceId,
        startDateTime: dayjs(startDate).toISOString(),
        endDateTime: dayjs(endDate).toISOString(),
      })
    );
    dispatch(
      fetchPressureRequest({
        // id: deviceid,
        id: shipBleDeviceId,
        startDateTime: dayjs(startDate).toISOString(),
        endDateTime: dayjs(endDate).toISOString(),
      })
    );
  };
  const handleInputChange = (value) => {
    dispatch(
      updateUI({
        key: "ui",
        value: {
          shipBleDeviceId: value,
        },
      })
    );
  };
  function getValueByDeviceAndKey(diviceid, key) {
    const item = deviceName?.devices?.find((obj) => obj?.uid === diviceid);
    return item ? item[key] : null;
  }
  return (
    <>
      <Grid2
        item
        xs={12}
        style={{
          backgroundColor: "#fff",
          borderRadius: "12px",
          marginBottom: "20px",
          padding: "1%",
        }}
      >
        <ShipmentFields shipmentData={shipmentData} />
      </Grid2>
      <Grid2
        container
        spacing={2}
        alignItems="center"
        style={{
          backgroundColor: "white", // White background for the grid container
          padding: "20px", // Padding for spacing inside the card
          borderRadius: "8px", // Rounded corners
          boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)", // Shadow effect to mimic card
          marginBottom: "0px",
        }}
      >
        <Grid2 item xs={3.25}>
          <Typography
            variant="body2"
            style={{
              marginBottom: "8px",
              textAlign: "left", // Align label to the left
            }}
          >
            Start date and time
          </Typography>
          <DatePicker
            showTime
            format="MM-DD-YYYY HH:mm"
            allowClear={false}
            onChange={onChangeStartDate}
            value={dayjs(startDate)}
            minDate={dayjs(shipmentData?.startdate || Date.now())}
            maxDate={dayjs(shipmentData?.updatedat || Date.now())}
            style={{
              width: "100%",
              height: "44px", // Increased height for DatePicker
              border: "1px solid black", // Black border for DatePicker
              borderRadius: "4px", // Optional rounded corners
            }}
          />
        </Grid2>

        {/* To Date Label and End Date Picker */}
        <Grid2 item xs={3.25}>
          <Typography
            variant="body2"
            style={{
              marginBottom: "8px",
              textAlign: "left", // Align label to the left
            }}
          >
            End date and time
          </Typography>
          <DatePicker
            showTime
            allowClear={false}
            format="MM-DD-YYYY HH:mm"
            onChange={onChangeEndDate}
            value={dayjs(endDate)}
            minDate={dayjs(shipmentData?.startdate || Date.now())}
            maxDate={dayjs(shipmentData?.updatedat || Date.now())}
            style={{
              width: "100%",
              height: "44px", // Increased height for DatePicker
              border: "1px solid black", // Black border for DatePicker
              borderRadius: "4px", // Optional rounded corners
            }}
          />
        </Grid2>
        {matchedDevice?.devicetype !== undefined && matchedDevice?.devicetype !== null?
        <Grid2 item xs={3.25}>
          <label htmlFor="device" className="input-label-user">
            Device name
          </label>
          <div className="input-container" style={{ marginTop: "5px" }}>
            <Select
              value={
                shipmentData?.deviceid
                  ? {
                      value: shipBleDeviceId,
                      label: getValueByDeviceAndKey(shipBleDeviceId, "name"),
                      //   label: (
                      //     <div>
                      //      {/* {getValueByDeviceAndKey(shipBleDeviceId, "name")} */}
                      //       <div className="device-drop-heading-down">{getValueByDeviceAndKey(shipBleDeviceId, "name")}</div>
                      //       {getValueByDeviceAndKey(shipBleDeviceId, "kind") === "ts.device.ble" && (
                      //         <div className="device-drop-down-label">Major: {getValueByDeviceAndKey(shipBleDeviceId, "major")}&nbsp;&nbsp; Minor: {getValueByDeviceAndKey(shipBleDeviceId, "minor")}</div>
                      //       )}
                      //     </div>
                      //  ),
                    }
                  : null
              }
              style={{ width: "100%", height: "44px" }}
              className="shipment-form-fields"
              onChange={(value) => handleInputChange(value)}
              options={(() => {
                const bleOptions = Array.isArray(shipmentData?.bledevice)
                  ? shipmentData.bledevice.map((item) => ({
                      value: item?.id,
                      //  label: getValueByDeviceAndKey(item?.id, "name"),
                      label: (
                        <div>
                          <div className="device-drop-down">
                            {getValueByDeviceAndKey(item?.id, "name")}
                          </div>
                          {getValueByDeviceAndKey(item?.id, "kind") ===
                            "ts.device.ble" && (
                            <div className="device-drop-down-label">
                              {getValueByDeviceAndKey(item?.id, "devicetype")
                                ?.toUpperCase()
                                ?.startsWith("MOCO SMART - N2") ? (
                                <>
                                  MAC:{" "}
                                  {calculateSerialMac(getValueByDeviceAndKey(item?.id, "serial"))}
                                </>
                              ) : (
                                !getValueByDeviceAndKey(
                                  item?.id,
                                  "devicetype"
                                )?.startsWith("Reelable") && (
                                  <>
                                    Major:{" "}
                                    {getValueByDeviceAndKey(item?.id, "major")}
                                    &nbsp;&nbsp; Minor:{" "}
                                    {getValueByDeviceAndKey(item?.id, "minor")}
                                  </>
                                )
                              )}
                            </div>
                          )}
                        </div>
                      ),
                    }))
                  : [];

                const defaultOption = {
                  value: shipmentData?.deviceid,
                  label:
                    getValueByDeviceAndKey(shipmentData?.deviceid, "name") ||
                    "Unknown Device",
                };

                const isDefaultInList = bleOptions.some(
                  (opt) => opt.value === defaultOption.value
                );

                return isDefaultInList
                  ? bleOptions
                  : [defaultOption, ...bleOptions];
              })()}
            />
          </div>
        </Grid2>:""}
        {/* Apply Button */}
        <Grid2 item xs={2}>
          <Button
            type="default"
            shape="round"
            onClick={handleLastUpdatedFilterChange}
            style={{
              backgroundColor: "white",
              border: "1px solid black", // Black border for the button
              width: "100%",
              marginTop: "25px",
              height: "44px", // Increased height for the button
              fontSize: "14px", // Optional font size adjustment
            }}
          >
            <h6 style={{ marginRight: "13%" }} className="font-face-vzw-header">
              Apply
            </h6>
          </Button>
        </Grid2>
      </Grid2>
      <ViewDeviceShipmentDashboard
        id={shipNewBleDeviceId}
        shipmentData={shipmentData}
        shipBleDeviceId={deviceid}
        // id={deviceid}
        startDateTime={startDate}
        endDateTime={endDate}
        gateway={true}
      />
    </>
  );
};

export default ShipmentData;
